import { memo, ReactNode, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react"

import './index.scss'
import AddItemForm from "../../../../components/AddItemForm"
import { NEW_AREA } from "./data"
import { useTranslation } from "react-i18next"
import Input from "../../../../components/Input"
import { DataDump } from "../../../Management"
import UserContext from "../../../../contexts/UserContext/context"
import Button from "../../../../components/Button"
import { InputError } from "../../../../components/Input/types"

type NewArea = {
  button: ReactNode
  drawingCallback: (shape: 'circle' | 'polygon' | null) => void
  saveData: (val: any) => any
  error: Record<string, InputError>
}

const NewArea = memo(({
  button, drawingCallback, saveData, error
}: NewArea) => {
  const formRef = useRef()
  const { t } = useTranslation()
  const { user } = useContext(UserContext)

  const [shape, setShape] = useState<'circle' | 'polygon'>('circle')

  const dataDump = useMemo(() => {
    const lookup: DataDump = {}
    if (user.available_fleets.length) {
      user.available_fleets.forEach((fleet) => {
        if (!lookup.fleets) lookup.fleets = {}
        lookup.fleets[fleet.fleetid] = fleet.name
      })
    }
    return lookup
  }, [user])

  useEffect(() => {
    formRef?.current?.setError(error)
  }, [error])

  useEffect(() => {
    drawingCallback(shape)
  }, [shape])

  const saveNewArea = useCallback(() => {
    const formValue = formRef?.current?.getData()
    saveData(formValue)
  }, [formRef, saveData])

  return (
    <div className="NewArea" >
      <div className="NewArea__new">{button}</div>
      <div className="NewArea__shape">
        <div className="NewArea__shape-label">{t('Area shape')}</div>
        <div className="NewArea__shape-radio">
          <Input
            type="radio"
            name="shape"
            label={t('Circle')}
            value={shape}
            valueKey="circle"
            onInput={(val) => setShape(val)}
          />
          <Input
            type="radio"
            name="shape"
            label={t('Polygon')}
            value={shape}
            valueKey="polygon"
            onInput={(val) => setShape(val)}
          />
        </div>
      </div>
      <div className="NewArea__form">
        <AddItemForm
          ref={formRef}
          inputs={NEW_AREA}
          dataInfo={dataDump}
        />
        <div className="NewArea__form-buttons">
          <Button
            type="secondary"
            size="m"
            label={t('Save area')}
            onClick={() => saveNewArea()}
          />
          <Button
            type="tertiary"
            size="m"
            label={t('Cancel drawing')}
            onClick={() => drawingCallback(null)}
          />
        </div>
      </div>
    </div>
  )
})

export default NewArea
